/**
 * Explicit live-editor disposition for a canvas that may be inspected but not
 * edited or solved. Persisted legacy canvases still use `sourceBoP` as a
 * compatibility marker; newly generated repair drafts use this typed state so
 * protection is active in the same render that creates the tab.
 */
export interface SimulationRepairDisposition {
  kind: 'protected-repair';
  origin: 'generated' | 'project-revision';
  reason: string;
}

export interface RepairProtectedTabLike {
  repairDisposition?: SimulationRepairDisposition;
  /** Historic persisted migration marker retained for backward compatibility. */
  sourceBoP?: string | null;
}

/** Resolve the authoritative read-only reason across the typed and legacy paths. */
export function repairDispositionReason(tab: RepairProtectedTabLike | null | undefined): string | null {
  const typedReason = tab?.repairDisposition?.reason.trim();
  if (tab?.repairDisposition?.kind === 'protected-repair') {
    return typedReason || 'Generated canvas requires explicit repair review.';
  }
  const legacyReason = typeof tab?.sourceBoP === 'string' ? tab.sourceBoP.trim() : '';
  return legacyReason || null;
}

export function isRepairProtectedTab(tab: RepairProtectedTabLike | null | undefined): boolean {
  return repairDispositionReason(tab) !== null;
}
